module.exports = __webpack_public_path__ + "media/pay-somebody.38e32d0b.mp3";